import React, {PropTypes} from 'react';

export default class Score extends React.Component {
    static propTypes = {
        score: PropTypes.object.isRequired,
        spanClass: PropTypes.string.isRequired,
        showNulls: PropTypes.bool
    };

    shouldComponentUpdate(nextProps) {
        return this.props.score !== nextProps.score;
    }

    render() {
        const {score, spanClass, showNulls} = this.props;

        let score1 = score.get('score1');
        let score2 = score.get('score2');

        if (!showNulls && (score1 === undefined || score2 === undefined)) {
            return false;
        } else {
            score1 = score1 || 0;
            score2 = score2 || 0;
        }

        return (
            <span className={spanClass}>{score1 + ':' + score2}</span>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/matchStats/Score.jsx